"use client";

/**
 * Demo band on the /use-cases hub — the two use-case demo videos, rendered
 * above the index grid so a visitor sees the product before the link list.
 * Reuses the homepage `landing.demos.*` copy and the short preview variants,
 * so the message and the assets stay single-sourced.
 */

import { Mail, GitBranch } from "lucide-react";
import { SectionHeader } from "@/components/marketing/marketing-kit";
import { VideoCard } from "@/components/marketing/video/video-card";
import { useT } from "@/i18n";

export function UseCaseDemoBand() {
  const t = useT();
  return (
    <div className="mb-20">
      <SectionHeader
        align="center"
        title={t("landing.demos.title")}
        description={t("landing.demos.intro")}
      />
      <div className="mx-auto mt-10 grid max-w-4xl gap-4 sm:grid-cols-2">
        <VideoCard
          href="/use-cases/support"
          title={t("landing.demos.support.title")}
          description={t("landing.demos.support.body")}
          cta={t("landing.demos.support.cta")}
          icon={<Mail size={18} />}
          previewId="fixcontrol-support-short-nl"
        />
        <VideoCard
          href="/use-cases/engineering"
          title={t("landing.demos.engineering.title")}
          description={t("landing.demos.engineering.body")}
          cta={t("landing.demos.engineering.cta")}
          icon={<GitBranch size={18} />}
          previewId="fixcontrol-engineering-short-nl"
        />
      </div>
    </div>
  );
}
